var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "58px",
    viewBox: "0 0 200 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 29.0263,
    y1: 40.6774,
    x2: 7.21544,
    y2: 18.338,
    gradientTransform: "matrix(1.111111,0,0,1.115385,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,62.745098%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    style: {
      stopColor: "rgb(0%,63.137255%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "rgb(0%,74.509804%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "rgb(0%,82.352941%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "rgb(0%,87.45098%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,89.019608%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0505,
    y1: 25.9982,
    x2: 12.8323,
    y2: 25.9982,
    gradientTransform: "matrix(1.111111,0,0,1.115385,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,87.843137%,0%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "rgb(100%,74.117647%,0%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "rgb(100%,64.705882%,0%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,61.176471%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 33.0572,
    y1: 23.0151,
    x2: 3.47986,
    y2: -7.27893,
    gradientTransform: "matrix(1.111111,0,0,1.115385,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,22.745098%,26.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(76.470588%,6.666667%,38.431373%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 9.71636,
    y1: 51.7709,
    x2: 22.924,
    y2: 38.2434,
    gradientTransform: "matrix(1.111111,0,0,1.115385,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(19.607843%,62.745098%,44.313725%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "rgb(17.647059%,65.490196%,44.313725%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "rgb(8.235294%,81.176471%,45.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "rgb(2.352941%,90.588235%,45.882353%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,94.117647%,46.27451%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 192.328125 58 L 7.398438 58 C 3.332031 58 0 54.734375 0 50.75 L 0 7.25 C 0 3.265625 3.332031 0 7.398438 0 L 192.328125 0 C 196.394531 0 199.726562 3.265625 199.726562 7.25 L 199.726562 50.75 C 199.726562 54.734375 196.394531 58 192.328125 58 Z M 192.328125 58 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(65.098039%,65.098039%,65.098039%)",
      fillOpacity: 1
    },
    d: "M 192.328125 1.160156 C 195.753906 1.160156 198.539062 3.894531 198.539062 7.25 L 198.539062 50.75 C 198.539062 54.105469 195.753906 56.839844 192.328125 56.839844 L 7.398438 56.839844 C 3.972656 56.839844 1.183594 54.105469 1.183594 50.75 L 1.183594 7.25 C 1.183594 3.894531 3.972656 1.160156 7.398438 1.160156 Z M 192.328125 0 L 7.398438 0 C 3.332031 0 0 3.265625 0 7.25 L 0 50.75 C 0 54.734375 3.332031 58 7.398438 58 L 192.328125 58 C 196.394531 58 199.726562 54.734375 199.726562 50.75 L 199.726562 7.25 C 199.726562 3.265625 196.394531 0 192.328125 0 Z M 192.328125 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 63.137109 13.315194 C 63.137109 14.400862 62.803125 15.272899 62.149219 15.920797 C 61.393359 16.687769 60.4125 17.076509 59.210156 17.076509 C 58.057031 17.076509 57.076172 16.680765 56.271094 15.906789 C 55.4625 15.122306 55.061719 14.155711 55.061719 13 C 55.061719 11.844289 55.4625 10.877694 56.271094 10.100216 C 57.076172 9.319235 58.057031 8.923491 59.210156 8.923491 C 59.779687 8.923491 60.328125 9.039062 60.848437 9.252694 C 61.36875 9.469828 61.790625 9.764009 62.096484 10.124731 L 61.400391 10.811153 C 60.866016 10.194774 60.138281 9.890086 59.210156 9.890086 C 58.369922 9.890086 57.642187 10.177263 57.023437 10.751616 C 56.415234 11.329472 56.109375 12.078933 56.109375 13 C 56.109375 13.921067 56.415234 14.67403 57.023437 15.255388 C 57.642187 15.822737 58.369922 16.116918 59.210156 16.116918 C 60.099609 16.116918 60.848437 15.822737 61.439062 15.248384 C 61.829297 14.866649 62.050781 14.337823 62.107031 13.665409 L 59.210156 13.665409 L 59.210156 12.726832 L 63.077344 12.726832 C 63.123047 12.929957 63.137109 13.126078 63.137109 13.315194 Z M 63.137109 13.315194 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 69.271875 10.061692 L 65.640234 10.061692 L 65.640234 12.530711 L 68.916797 12.530711 L 68.916797 13.469289 L 65.640234 13.469289 L 65.640234 15.938308 L 69.271875 15.938308 L 69.271875 16.897899 L 64.610156 16.897899 L 64.610156 9.102101 L 69.271875 9.102101 Z M 69.271875 10.061692 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 73.603125 16.897899 L 72.576562 16.897899 L 72.576562 10.061692 L 70.347656 10.061692 L 70.347656 9.102101 L 75.835547 9.102101 L 75.835547 10.061692 L 73.603125 10.061692 Z M 73.603125 16.897899 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 79.804687 16.897899 L 79.804687 9.102101 L 80.83125 9.102101 L 80.83125 16.897899 Z M 79.804687 16.897899 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 85.383984 16.897899 L 84.364453 16.897899 L 84.364453 10.061692 L 82.128516 10.061692 L 82.128516 9.102101 L 87.619922 9.102101 L 87.619922 10.061692 L 85.383984 10.061692 Z M 85.383984 16.897899 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 98.008594 15.89278 C 97.221094 16.680765 96.247266 17.076509 95.083594 17.076509 C 93.912891 17.076509 92.939062 16.680765 92.151562 15.89278 C 91.367578 15.108297 90.973828 14.141703 90.973828 13 C 90.973828 11.858297 91.367578 10.891703 92.151562 10.10722 C 92.939062 9.319235 93.912891 8.923491 95.083594 8.923491 C 96.240234 8.923491 97.217578 9.319235 98.005078 10.110722 C 98.796094 10.905711 99.186328 11.865302 99.186328 13 C 99.186328 14.141703 98.796094 15.108297 98.008594 15.89278 Z M 92.910937 15.241379 C 93.505078 15.822737 94.225781 16.116918 95.083594 16.116918 C 95.937891 16.116918 96.662109 15.822737 97.249219 15.241379 C 97.839844 14.656519 98.138672 13.907058 98.138672 13 C 98.138672 12.092942 97.839844 11.343481 97.249219 10.758621 C 96.662109 10.177263 95.937891 9.883082 95.083594 9.883082 C 94.225781 9.883082 93.505078 10.177263 92.910937 10.758621 C 92.320312 11.343481 92.021484 12.092942 92.021484 13 C 92.021484 13.907058 92.320312 14.656519 92.910937 15.241379 Z M 92.910937 15.241379 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 100.63125 16.897899 L 100.63125 9.102101 L 101.879297 9.102101 L 105.760547 15.164332 L 105.802734 15.164332 L 105.760547 13.665409 L 105.760547 9.102101 L 106.787109 9.102101 L 106.787109 16.897899 L 105.714844 16.897899 L 101.650781 10.537985 L 101.605078 10.537985 L 101.650781 12.040409 L 101.650781 16.897899 Z M 100.63125 16.897899 ",
    transform: "matrix(1.111111,0,0,1.115385,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.800781 31.542969 C 97.328125 31.542969 94.488281 34.132812 94.488281 37.710938 C 94.488281 41.257812 97.328125 43.875 100.800781 43.875 C 104.285156 43.875 107.121094 41.257812 107.121094 37.710938 C 107.121094 34.132812 104.285156 31.542969 100.800781 31.542969 Z M 100.800781 41.445312 C 98.894531 41.445312 97.253906 39.902344 97.253906 37.710938 C 97.253906 35.484375 98.894531 33.96875 100.800781 33.96875 C 102.707031 33.96875 104.355469 35.484375 104.355469 37.710938 C 104.355469 39.902344 102.707031 41.445312 100.800781 41.445312 Z M 87.027344 31.542969 C 83.542969 31.542969 80.714844 34.132812 80.714844 37.710938 C 80.714844 41.257812 83.542969 43.875 87.027344 43.875 C 90.507812 43.875 93.339844 41.257812 93.339844 37.710938 C 93.339844 34.132812 90.507812 31.542969 87.027344 31.542969 Z M 87.027344 41.445312 C 85.117188 41.445312 83.472656 39.902344 83.472656 37.710938 C 83.472656 35.484375 85.117188 33.96875 87.027344 33.96875 C 88.933594 33.96875 90.574219 35.484375 90.574219 37.710938 C 90.574219 39.902344 88.933594 41.445312 87.027344 41.445312 Z M 70.632812 33.433594 L 70.632812 36.050781 L 77.019531 36.050781 C 76.832031 37.515625 76.332031 38.59375 75.566406 39.34375 C 74.636719 40.25 73.183594 41.257812 70.632812 41.257812 C 66.703125 41.257812 63.628906 38.148438 63.628906 34.296875 C 63.628906 30.445312 66.703125 27.335938 70.632812 27.335938 C 72.757812 27.335938 74.304688 28.148438 75.445312 29.203125 L 77.332031 27.359375 C 75.734375 25.863281 73.613281 24.71875 70.632812 24.71875 C 65.246094 24.71875 60.714844 29.015625 60.714844 34.296875 C 60.714844 39.578125 65.246094 43.875 70.632812 43.875 C 73.546875 43.875 75.734375 42.941406 77.453125 41.183594 C 79.21875 39.457031 79.765625 37.03125 79.765625 35.066406 C 79.765625 34.460938 79.714844 33.898438 79.621094 33.433594 Z M 137.664062 35.464844 C 137.144531 34.085938 135.542969 31.542969 132.277344 31.542969 C 129.039062 31.542969 126.34375 34.039062 126.34375 37.710938 C 126.34375 41.164062 129.011719 43.875 132.585938 43.875 C 135.476562 43.875 137.144531 42.148438 137.832031 41.140625 L 135.6875 39.742188 C 134.96875 40.765625 133.996094 41.445312 132.585938 41.445312 C 131.1875 41.445312 130.183594 40.816406 129.539062 39.578125 L 137.953125 36.164062 Z M 129.082031 37.515625 C 129.011719 35.140625 130.96875 33.921875 132.371094 33.921875 C 133.46875 33.921875 134.398438 34.460938 134.710938 35.230469 Z M 122.242188 43.5 L 125.007812 43.5 L 125.007812 25.375 L 122.242188 25.375 Z M 117.710938 32.914062 L 117.621094 32.914062 C 116.996094 32.195312 115.8125 31.542969 114.3125 31.542969 C 111.160156 31.542969 108.277344 34.253906 108.277344 37.730469 C 108.277344 41.183594 111.160156 43.875 114.3125 43.875 C 115.8125 43.875 116.996094 43.21875 117.621094 42.472656 L 117.710938 42.472656 L 117.710938 43.359375 C 117.710938 45.714844 116.425781 46.984375 114.351562 46.984375 C 112.664062 46.984375 111.613281 45.789062 111.183594 44.78125 L 108.777344 45.765625 C 109.46875 47.402344 111.304688 49.414062 114.351562 49.414062 C 117.597656 49.414062 120.335938 47.542969 120.335938 42.992188 L 120.335938 31.917969 L 117.710938 31.917969 Z M 114.546875 41.445312 C 112.640625 41.445312 111.046875 39.882812 111.046875 37.730469 C 111.046875 35.554688 112.640625 33.96875 114.546875 33.96875 C 116.425781 33.96875 117.90625 35.554688 117.90625 37.730469 C 117.90625 39.882812 116.425781 41.445312 114.546875 41.445312 Z M 150.617188 25.375 L 144 25.375 L 144 43.5 L 146.757812 43.5 L 146.757812 36.632812 L 150.617188 36.632812 C 153.679688 36.632812 156.6875 34.460938 156.6875 31.003906 C 156.6875 27.546875 153.671875 25.375 150.617188 25.375 Z M 150.6875 34.109375 L 146.757812 34.109375 L 146.757812 27.894531 L 150.6875 27.894531 C 152.75 27.894531 153.925781 29.574219 153.925781 31.003906 C 153.925781 32.40625 152.75 34.109375 150.6875 34.109375 Z M 167.746094 31.507812 C 165.75 31.507812 163.679688 32.371094 162.824219 34.28125 L 165.273438 35.289062 C 165.800781 34.28125 166.769531 33.957031 167.792969 33.957031 C 169.226562 33.957031 170.679688 34.796875 170.699219 36.285156 L 170.699219 36.476562 C 170.199219 36.195312 169.132812 35.773438 167.816406 35.773438 C 165.179688 35.773438 162.492188 37.199219 162.492188 39.851562 C 162.492188 42.28125 164.652344 43.847656 167.082031 43.847656 C 168.9375 43.847656 169.960938 43.023438 170.605469 42.070312 L 170.699219 42.070312 L 170.699219 43.472656 L 173.367188 43.472656 L 173.367188 36.519531 C 173.367188 33.304688 170.917969 31.507812 167.746094 31.507812 Z M 167.414062 41.4375 C 166.511719 41.4375 165.253906 41 165.253906 39.902344 C 165.253906 38.5 166.820312 37.964844 168.179688 37.964844 C 169.390625 37.964844 169.960938 38.226562 170.699219 38.570312 C 170.484375 40.25 169.011719 41.4375 167.414062 41.4375 Z M 183.074219 31.902344 L 179.902344 39.761719 L 179.808594 39.761719 L 176.527344 31.902344 L 173.554688 31.902344 L 178.480469 42.882812 L 175.667969 48.992188 L 178.550781 48.992188 L 186.144531 31.902344 Z M 158.203125 43.5 L 160.96875 43.5 L 160.96875 25.375 L 158.203125 25.375 Z M 158.203125 43.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 15.4375 10.929688 C 15.003906 11.378906 14.75 12.070312 14.75 12.96875 L 14.75 45.035156 C 14.75 45.9375 15.003906 46.628906 15.4375 47.074219 L 15.546875 47.175781 L 33.878906 29.210938 L 33.878906 28.789062 L 15.546875 10.824219 Z M 15.4375 10.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 39.984375 35.203125 L 33.878906 29.210938 L 33.878906 28.789062 L 39.992188 22.796875 L 40.128906 22.875 L 47.367188 26.910156 C 49.433594 28.058594 49.433594 29.941406 47.367188 31.09375 L 40.128906 35.125 Z M 39.984375 35.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 40.128906 35.125 L 33.878906 29 L 15.4375 47.074219 C 16.125 47.78125 17.242188 47.867188 18.515625 47.160156 Z M 40.128906 35.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 40.128906 22.875 L 18.515625 10.839844 C 17.242188 10.140625 16.125 10.222656 15.4375 10.929688 L 33.878906 29 Z M 40.128906 22.875 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.4646d0bbaec4ea454d2ca9fc38278ee9.svg";
export { ForwardRef as ReactComponent };